import { StateType } from '../../index';

export const notificationsDataSelector = (state: StateType) => state.getIn(['dashboard', 'notifications', 'data']);
export const notificationsIsFetchingSelector = (state: StateType) => state.getIn(['dashboard', 'notifications', 'isFetching']);
